export default __webpack_public_path__ + "static/media/UrbanA.76c0ab76.jpeg";